/*  */

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { koalaImg } from "utility/koalaImg";

import { Button } from "antd";
import { Image } from "antd";
import ModalAlert from "components/modal/ModalAlert";
import logo from "../../assets/imgage/wordBook/workBookLogoNew.png"
import heart from "../../assets/imgage/wordBook/ico-heart.svg"
import helper from "services/helper";
import ModalHowToPlay from "./ModalHowToPlay";
import { RewardWordBook } from "services/Api/Module/Reward";
import GetCurrentPoint from "../profile/GetCurrentPoint";

const WordBookMenu = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [openHowToPlay, setOpenHowToPlay] = useState(false);
    const [tootip, setTootip] = useState(false);
    const navigate = useNavigate();
    const stateProfile = useSelector((state) => state.profile.dataUser);
    const stateCurrentPoint = useSelector((state) => state.currentPoint);
    const haveLucky = stateCurrentPoint.haveLucky;
    const redeemLucky = stateCurrentPoint.redeemLucky;
    const redeemHeart = stateCurrentPoint.redeemHeart;
    const newCurrentHeart = redeemHeart ? 10 : stateCurrentPoint.currentHeart;
    const customerId = stateProfile.id;
    const [rewardData, setRewardData] = useState({});

    // const { mAlert } = useContext(ModalContext);


    useEffect(() => {
        fetchRewardView();
        console.log(stateCurrentPoint.currentHeart)
        document.documentElement.scrollTop = 0;
    }, []);

    const getRewardView = async () => {
        let _return = {
            status: false,
            result: {},
            rowCount: 0,
        };
        try {
            const { data } = await RewardWordBook({
                data: { customer: customerId }
            });
            if (data.resultCode === "20000") {
                const resData = data.resultData;
                const rowCount = data.rowCount;

                _return.status = true;
                _return.result = resData;
                _return.rowCount = rowCount;
            } else {
                navigate("/reward");
            }
        } catch (e) {
            console.log(e);
            return _return;
        }
        return _return;
    };

    const fetchRewardView = async () => {
        try {
            const resData = await getRewardView();
            setRewardData(resData.result);
        } catch (err) {
            console.log(err);
        }
    };



    return (
        <div>
            <GetCurrentPoint />
            <Helmet>
                <title>โคอะลา มาร์ช</title>
                <meta name="title" content="โคอะลา มาร์ช" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="โคอะลา มาร์ช" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>

            <div id="pageWordBookMain">
                {/* <!-- Content Page --> */}
                <main>
                    <div className="wrapContent">
                        {/* <section id="pTitlePage">
                            <div className="bTitlePage">
                                <a
                                    className="btnIconBack"
                                    onClick={() => navigate(`/profile`)}
                                ></a>
                                <h2>Wordbook</h2>
                            </div>
                        </section> */}
                        <div className="bTop">
                            <a className="btnGoHome"
                                onClick={() => { navigate("/profile") }}
                            ></a>
                            <a className="howToPlay" onClick={() => setOpenHowToPlay(true)}> วิธีการเล่น</a>
                            <div className="divHeart">
                                {/* <a className="iconHeart"></a> */}
                                <Image preview={false} src={heart}></Image>
                                <span>{newCurrentHeart}/10</span>
                                <a className="iconInfo" onClick={() => setTootip(true)}></a>
                                <div className="bTips" style={{ display: tootip ? 'block' : 'none' }} >
                                    <a className="btnCloseTips" onClick={() => setTootip(false)}></a>
                                    <p className="bold">เก็บหัวใจครบ 10 ดวง <br></br>เพื่อแลกของรางวัล</p>
                                    <p>
                                        เก็บสะสม Wordbook จากการสแกน สะสมคะแนน เพื่อตอบคำถามในกิจกรรม ตอบ 1 คำถาม รับไปเลย 1 ดวง!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <section id="pLogo">
                            <Image preview={false} src={logo}></Image>

                        </section>
                        <section id="pEvent">

                            <div className="bBanner" id="myWordBookBanner">
                                <Button onClick={() => navigate('/word-book-all')}>ดูทั้งหมด</Button>
                            </div>

                            <div className="bBanner" id="wordBookQuizBanner">
                                <Button onClick={() => navigate('/word-book-quiz')}>ไปตอบคำถาม</Button>
                            </div>
                            <div className="bBanner prize" id="wordBookPrizeBanner">
                                <div className="countRewards">เหลือรางวัลอีก {rewardData.available} ชิ้น
                                    <div className="percectRewards"
                                        style={{
                                            width:
                                                helper.FN.calPercen(`${rewardData.used}`, `${rewardData.total}`) + "%",
                                        }}
                                    > </div>
                                </div>
                                {redeemHeart ?
                                    <Button disabled={true}>แลกสำเร็จ</Button>
                                    :
                                    <Button disabled={newCurrentHeart < 10 || rewardData.used === rewardData.total} onClick={() => { navigate("/word-book-prize") }}>แลกของรางวัล</Button>
                                }

                            </div>
                            <div className="bBanner" id="luckyWordPrizeBanner">
                                {redeemLucky ?
                                    <Button disabled={true}>แลกสำเร็จ</Button>
                                    :
                                    <Button disabled={!haveLucky} onClick={() => { navigate("/word-book-prize?lucky=true") }}>แลกของรางวัล</Button>
                                }

                            </div>

                        </section>

                    </div>
                </main>
            </div >
            <ModalAlert
                open={openPopup}
                title='title'
                subTitle='subTitle'
                content='content'
                onClose={() => setOpenPopup(false)}
            />
            <ModalHowToPlay
                isOpen={openHowToPlay}
                onClose={() => setOpenHowToPlay(false)}
            />
        </div >
        
    );
};

export default WordBookMenu;
